import React, { useContext, useEffect, useState, useMemo } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { getLocalAuthStorage } from 'utils/localStorage';
import { AuthContext } from 'context/AuthContext';
import { FiltersContext } from 'context/GlobalFiltersContext';
import { usePermissions } from 'hooks/usePermission';
import jwt from 'jwt-decode';
import { useCookies } from 'react-cookie';
import { Loading } from 'components/Loading';

import { getPageAction } from './routePermissionsMap'; // ⬅ novo import
import * as Sentry from '@sentry/react';
//import { CustomerPortal } from 'pages/CustomerPortal';
const CustomerPortal = React.lazy(() => import('pages/CustomerPortal'));
const PrivateRoute = ({ path, Component, page, ..._rest }) => {
  const { permissionContext } = usePermissions();
  const navigate = useNavigate();
  const { setAuthContext } = useContext(AuthContext);
  const { headerFiltersContext } = useContext(FiltersContext);
  const { headerFilters } = headerFiltersContext;
  const [cookie] = useCookies();
  const companyId = headerFilters?.companies?.id;
  const empresaAttrs = useMemo(
    () => ({ empresa_id: cookie?.companies?.id, empresa_name: cookie?.companies?.name }),
    [cookie?.companies?.id, cookie?.companies?.name],
  );

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const authStorage = getLocalAuthStorage();
    if (cookie?.chamadoRoute?.startsWith('/chamado/')) {
      Sentry.logger.info('[logout] private route', empresaAttrs);
      navigate('/logout');
      return;
    }
    if (!authStorage || !authStorage.isAuthenticated || !authStorage.token) {
      setAuthContext({
        statusCode: false,
        isAuthenticated: false,
        token: null,
        refreshToken: null,
        expiresIn: null,
        user: {
          name: null,
          permissionType: null,
        },
      });

      navigate('/login');
    }
    setLoading(false);
  }, [setAuthContext, cookie?.chamadoRoute, navigate, empresaAttrs]);

  if (loading) {
    return <Loading />;
  }
  const authStorage = getLocalAuthStorage();
  if (!authStorage || !authStorage.isAuthenticated || !authStorage.token) {
    return null;
  } else {
    const { token } = getLocalAuthStorage();
    const { utyp } = jwt(token);
    const tipoUsuario = JSON.parse(utyp);
    if (path === '/home') {
      return <Navigate to="/dashboard" replace />;
    }
    if (tipoUsuario === 1) {
      if (path === '/portal-do-cliente') {
        return <Navigate to="/dashboard" replace />;
      }
      return <Component companyId={companyId} />;
    } else if ((page === 'config' || page === 'cadastros') && tipoUsuario === 2) {
      return <Component companyId={companyId} />;
    } else if (tipoUsuario === 4) {
      if (path !== '/portal-do-cliente') {
        return <Navigate to="/portal-do-cliente" replace />;
      }
      return <CustomerPortal companyId={companyId} />;
    } else if (page === 'dashboard' || permissionContext[page]) {
      return <Component companyId={companyId} />;
    } else {
      return <Navigate to="/permission-error" replace />;
    }
  }

  // ---------------------------
  // 🔐 NOVA LÓGICA DE PERMISSÕES (granular e compatível)
  // ---------------------------
  const perm = permissionContext[page];

  const hasAccess = (() => {
    if (!perm) return false;

    // 🔹 Telas antigas: boolean → continua igual
    if (typeof perm === 'boolean') return perm;

    // 🔹 Telas novas: objeto → permissões por ação
    if (typeof perm === 'object') {
      const action = getPageAction(page, path);
      if (!action) return false;
      return perm[action] === true;
    }

    return false;
  })();

  if (!hasAccess) {
    navigate('/permission-error');
    return null;
  }

  return <Component companyId={companyId} />;
};

export default PrivateRoute;
